import { parameterService } from '../../../services';
import { encode } from 'querystring';

export default async function checkIsIsoCodeProvinceHaveBranch(isocode) {
  const params = new URLSearchParams(
    encode({
      isOnlyHaveBranch: true,
    })
  );
  const res = await parameterService.getListProvince(params);
  const provinceHaveBranchList = res.data;
  const provinceDetail = provinceHaveBranchList.find((item) => item.isocode === isocode);
  const isProvinceHaveBranch = provinceDetail !== undefined;

  return {
    isProvinceHaveBranch,
    data: provinceDetail,
  };
}
